type JavascriptChannel = { callHandler: (...params: any[]) => Promise<any> };

export interface CurrentHealthTrackerData {
  trackerType: string;
  date: string;
  value: number;
}

interface HealthTrackerDataWithData extends CurrentHealthTrackerData {
  date: string;
}

export const dial = (number: string) => window.flutter_inappwebview?.callHandler("dial", number);

export const openExternalLink = (url: string) => window.flutter_inappwebview?.callHandler("openExternalLink", url);

export const copyToClipboard = (text: string) => window.flutter_inappwebview?.callHandler("copyToClipboard", text);

export const getMobilePlatform = async (): Promise<string> => await window.flutter_inappwebview?.callHandler("getPlatform");

export const share = (fileUrl: string, fileName: string) => window.flutter_inappwebview?.callHandler("shareFile", fileUrl, fileName);

export const loadAudio = ({ src, title }: { src: string; title: string }): Promise<AudioPlayerState | undefined> | undefined =>
  window.flutter_inappwebview?.callHandler("loadAudio", src, title);

export const playAudio = () => window.flutter_inappwebview?.callHandler("playAudio");

export const pauseAudio = () => window.flutter_inappwebview?.callHandler("pauseAudio");

export const stopAudio = () => window.flutter_inappwebview?.callHandler("stopAudio");

export const seekAudio = (position: number) => window.flutter_inappwebview?.callHandler("seekAudio", position);

export const setAudioSeekState = (isSeeking: boolean) => window.flutter_inappwebview?.callHandler("setAudioSeekState", isSeeking);

export const authenticateMobileUser = (clientCode: string, userObject: string) =>
  window.flutter_inappwebview?.callHandler("authentication", clientCode, userObject);

export const flutterAppOpen = async (): Promise<string> => await window.flutter_inappwebview?.callHandler("flutterAppOpen");

export const getAppVersion = async (): Promise<string> => await window.flutter_inappwebview?.callHandler("getAppVersion");

export const getDeviceInfo = async (): Promise<string> => await window.flutter_inappwebview?.callHandler("getDeviceInfo");

export const writeDownloadFile = async (content: string, fileName: string) =>
  await window.flutter_inappwebview?.callHandler("writeDownloadFile", content, fileName);

export const getFlutterUser = async (): Promise<any> => await window.flutter_inappwebview?.callHandler("getFlutterUser");

export const getRefreshedUser = async (): Promise<any> => await window.flutter_inappwebview?.callHandler("getRefreshedUser");

export const getClientDetails = async (): Promise<any> => await window.flutter_inappwebview?.callHandler("getClientDetails");

export const onLogout = () => window.flutter_inappwebview?.callHandler("onLogout");

export const playHaptic = () => window.flutter_inappwebview?.callHandler("successHaptic");

export const playErrorHaptic = () => window.flutter_inappwebview?.callHandler("errorHaptic");

export const updateClientDetails = () => window.flutter_inappwebview?.callHandler("updateClientDetails");

export const onBiometricSetup = async (enableBiometric: boolean) =>
  await window.flutter_inappwebview?.callHandler("onBiometricSetup", enableBiometric);

export const onBiometricStatus = async (): Promise<number> => await window.flutter_inappwebview?.callHandler("onBiometricStatus");

export const onSsoSetup = (provider: string) => window.flutter_inappwebview?.callHandler("onSsoSetup", provider);

export const getMediaPermissions = async (): Promise<string[]> => await window.flutter_inappwebview?.callHandler("getMediaPermissions");

export const getSyncedHealthTrackers = async (): Promise<string[]> => await window.flutter_inappwebview?.callHandler("getSyncedHealthTrackers");

export const fetchSystemInsetPadding = async (): Promise<Record<string, any>> =>
  await window.flutter_inappwebview?.callHandler("fetchSystemInsetPadding");

export const setTopBottomSafeArea = (safeAreaValue: boolean) => window.flutter_inappwebview?.callHandler("setTopBottomSafeArea", safeAreaValue);

export const confirmWebAppReady = () => window.flutter_inappwebview?.callHandler("confirmWebAppReady");

export const onAppReviewTrigger = async (): Promise<void> => await window.flutter_inappwebview?.callHandler("onAppReviewTrigger");

export const isAppReviewRequestAvailable = async (): Promise<boolean> =>
  await window.flutter_inappwebview?.callHandler("isAppReviewRequestAvailable");

export const getHealthTrackerData = async (trackerType: string, fromDate: string): Promise<HealthTrackerDataWithData[]> =>
  await window.flutter_inappwebview?.callHandler("getHealthTrackerData", trackerType, fromDate);

export const getCurrentHealthData = async (): Promise<CurrentHealthTrackerData[]> =>
  await window.flutter_inappwebview?.callHandler("getCurrentHealthData");

export type AudioPlayerState = {
  isPlaying: boolean;
  durationInSeconds: number;
  positionInSeconds: number;
};

declare global {
  interface Window {
    flutter_inappwebview?: JavascriptChannel;
    updateAudioProgress?: (progress: number) => void;
    backgroundAudioEnabled?: boolean;
    interdeal: any;
  }
}
